import { TreeNode } from 'primeng/api';
import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class SubsidiaryCharacteristicsCriteria extends FilterCriteria {
  public override title = 'Characteristics of a Subsidiary';
  public override type: FilterTypes = FilterTypes.SubsidiaryCharacteristics;
  subsidiaryCharacteristics: TreeNode[] = null;
  minimumPercent: number = null;
  maximumPercent: number = null;
  includeUnknownPercent: boolean = null;

  public override validate(): boolean {
    if (!this.subsidiaryCharacteristics || this.subsidiaryCharacteristics.length < 1) {
      return false;
    }
    if (!this.checkFalseExceptZero(this.minimumPercent) && !this.checkFalseExceptZero(this.maximumPercent)) {
      return false;
    }
    if (
      this.checkFalseExceptZero(this.maximumPercent) &&
      this.checkFalseExceptZero(this.minimumPercent) &&
      parseInt(this.minimumPercent.toString(), 10) > parseInt(this.maximumPercent.toString(), 10)
    ) {
      return false;
    }
    return true;
  }

  public override toString(): string {
    const s: string[] = [];
    if (this.minimumPercent || this.maximumPercent) {
      s.push(`Min %: ${this.minimumPercent ? this.minimumPercent : 'N/A'}, Max %: ${this.maximumPercent ? this.maximumPercent : 'N/A'}`);
    }
    if (this.includeUnknownPercent === true) {
      s.push('Include Subsidiaries with Unknown %');
    }
    if (this.subsidiaryCharacteristics) {
      s.push(`Types: ${this.subsidiaryCharacteristics.map((a) => a.label).join(', ')}`);
    }
    return s.join(' | ');
  }

  checkFalseExceptZero(value): boolean {
    if (Array.isArray(value)) {
      return !!value.length;
    }
    return value === 0 || !!value;
  }
}
